import { Input } from 'antd';
import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { selectGroupMergeError } from 'Selector/GroupsSelector';
import { ENTER_GROUP_NAME } from 'Utils/Constants';

const Wrapper = styled.div``;

type Props = {
  inputValue: string
  setInputValue: (a: string) => void,

};

const MergeInputModal = function MergeInputModal(props: Props) {
  const { inputValue, setInputValue } = props;
  const error = useSelector(selectGroupMergeError);
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  return (
    <Wrapper className="merge-input-modal-wrapper">
      <div className="title-error-msg-div">
        <p className="options-text">Name your Group:</p>
        {error ? <p className="options-text error">{error}</p> : null}
      </div>
      <Input
        placeholder={ENTER_GROUP_NAME}
        status={error ? 'error' : ''}
        allowClear={{ clearIcon: <CloseOutlined /> }}
        value={inputValue}
        onChange={handleInputChange}
        maxLength={40}
      />
    </Wrapper>
  );
};
export default MergeInputModal;
